// @flow

import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const FormsIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      d="M20.496 5.76841L16.7352 2.00641C16.5992 1.87281 16.4158 1.79858 16.2252 1.80001H7.94519C7.75423 1.80001 7.57109 1.87586 7.43607 2.01089C7.30104 2.14592 7.22519 2.32905 7.22519 2.52001V5.71801H4.01279C3.82183 5.71801 3.63869 5.79387 3.50367 5.92889C3.36864 6.06392 3.29279 6.24705 3.29279 6.43801V21.48C3.29279 21.671 3.36864 21.8541 3.50367 21.9891C3.63869 22.1242 3.82183 22.2 4.01279 22.2H16.05C16.2409 22.2 16.4241 22.1242 16.5591 21.9891C16.6941 21.8541 16.77 21.671 16.77 21.48V18.282H19.9872C20.1781 18.282 20.3613 18.2062 20.4963 18.0711C20.6313 17.9361 20.7072 17.753 20.7072 17.562V6.28201C20.7077 6.18668 20.6893 6.09219 20.6531 6.00403C20.6168 5.91586 20.5634 5.83577 20.496 5.76841ZM15.33 20.76H4.73279V7.15801H7.21799V17.5584C7.21786 17.7132 7.26764 17.864 7.35994 17.9882C7.45224 18.1125 7.58214 18.2038 7.73039 18.2484C7.80147 18.2706 7.87551 18.282 7.94999 18.282H15.33V20.76ZM19.2672 16.8384H16.1232C16.0988 16.8372 16.0744 16.8372 16.05 16.8384H8.66999V3.24001H15.9276L19.2672 6.57601V16.8384Z"
    />
    <path
      fill={props.color}
      d="M14.04 4.63324H12.6V9.08764C12.6 9.2786 12.6759 9.46173 12.8109 9.59676C12.9459 9.73178 13.129 9.80764 13.32 9.80764H17.7756V8.36764H14.04V4.63324Z"
    />
  </IconSvgWrapper>
);

FormsIcon.defaultProps = defaultIconProps;

export default FormsIcon;
